export const platformsConfig = [
    {
        value: 1,
        label: 'X',
        color: '#FF6584',
    },
    {
        value: 2,
        label: 'Instagram',
        color: '#FFD864',
    },
    {
        value: 3,
        label: 'Facebook',
        color: '#329FE9',
    },
    {
        value: 23,
        label: 'Tiktok',
        color: '#5232E9',
    },
];

export const mediaTypeConfig = [
    {
        value: 1,
        label: 'Image',
        color: '#FF6584',
    },
    {
        value: 2,
        label: 'Video',
        color: '#FFD864',
    },
    {
        value: 3,
        label: 'Text',
        color: '#329FE9',
    },
];
